import React from 'react'
import Footer from '../components/footerComponent/footer'
import CopyLesson from '../components/teacherComponent/copyLessonComponent'
import Header from '../components/headerComponent/header'
import {Layout} from 'antd';

export default function CopyLessonPage() {
    return (
        <Layout>
            <Header/>
            <CopyLesson/>
            <Footer/>
        </Layout>
    );
};